import React from 'react'
import {
  WRITING_FONT_KEYS,
  WRITING_FONT_LABELS,
  resolveWritingFontKey,
  writingFontFamily,
} from 'lib/writingFont'

/**
 * Compact catalog picker for writing-mode panel / sheet.
 */
export default function WritingFontPicker({
  value,
  onChange,
  disabled = false,
  id = 'writing-mode-font-picker',
}) {
  const selected = resolveWritingFontKey(value)

  return (
    <div className="writing-font-picker" data-testid="writing-font-picker">
      <label
        htmlFor={id}
        style={{ fontSize: '0.75rem', opacity: 0.7, display: 'block', marginBottom: '0.35rem' }}
      >
        Writing font
      </label>
      <select
        id={id}
        className="form-select form-select-sm"
        aria-label="Writing font"
        value={selected}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.value)}
        style={{
          background: '#111',
          color: '#e8e8e8',
          borderColor: '#444',
          fontFamily: writingFontFamily(selected),
        }}
      >
        {WRITING_FONT_KEYS.map((key) => (
          <option key={key} value={key} style={{ fontFamily: writingFontFamily(key) }}>
            {WRITING_FONT_LABELS[key]}
          </option>
        ))}
      </select>
    </div>
  )
}
